import { defineMessages } from 'react-intl';

export default defineMessages({
  edit: {
    id: 'kustomer.chat.satisfactionSurvey.button.edit',
    description: 'edit button',
    defaultMessage: 'Edit',
  },
  submit: {
    id: 'kustomer.chat.satisfactionSurvey.button.submit',
    description: 'submit button',
    defaultMessage: 'Submit',
  },
  feedback_thanks: {
    id: 'kustomer.chat.satisfactionSurvey.feedback.thanks',
    description: 'thanks for feedback message',
    defaultMessage: 'Thank you for your feedback!',
  },
  max_length: {
    id: 'kustomer.chat.satisfactionSurvey.questions.field.max_length',
    description: 'max length',
    defaultMessage: '{count} / {max} characters',
  },
});
